import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Alert, Flex, Icon, Modal, Tag, Text } from '~/components/blocks';
import { SelectMonthWithMoveButton } from '~/components/pages/Reception/BookmarkPatientListModal/SelectMonthWithMoveButton';
import { bookmarkPatientListModalState } from '~/state/reception/atoms';

import { BookmarkPatientList } from './BookmarkPatientList';

const CustomTag = styled(Tag)(() =>
  css({
    alignItems: 'center',
    display: 'inline-flex',
    margin: '0px',
    textAlign: 'start',
    verticalAlign: 'bottom',
    whiteSpace: 'nowrap',
  }),
);

export const BookmarkPatientListModal = () => {
  const theme = useTheme();

  const [{ isOpen, error, yearMonth, patientCount }, setModalState] = useAtom(
    bookmarkPatientListModalState,
  );
  const resetModalState = useResetAtom(bookmarkPatientListModalState);

  const handleClose = useCallback(() => resetModalState(), [resetModalState]);

  const handleChange = useCallback(
    (date: Date | null) => {
      setModalState((_state) => ({ ..._state, yearMonth: date }));
    },
    [setModalState],
  );

  return (
    <Modal size="l" open={isOpen} onClose={handleClose}>
      <Modal.Header>お気に入り薬局登録患者</Modal.Header>
      <Flex marginTop={theme.space.m}>
        <CustomTag>
          <Icon icon="favorite-fill" color="pink" size="l" />
          お気に入り薬局登録患者数&nbsp;
          <Text fontWeight="bold">{patientCount}名</Text>
        </CustomTag>
        <Flex marginLeft={theme.space.m}>
          <SelectMonthWithMoveButton
            value={yearMonth}
            onChange={handleChange}
            maxDate={new Date()}
          />
        </Flex>
      </Flex>
      <Text size="m" fontWeight="normal" marginTop={theme.space.m}>
        お気に入り登録した患者の申し込み数を確認できます。
        <br />
        申し込みをしていない患者は表示されません
      </Text>
      <Modal.Body>
        {error && (
          <Alert status="error" whiteSpace="pre-wrap" marginBottom={theme.space.l}>
            {error}
          </Alert>
        )}
        <BookmarkPatientList />
      </Modal.Body>
    </Modal>
  );
};
